import { assign, setup } from 'xstate';

export const playMachine = setup({
  types: {} as {
    context: { error?: string };
    events:
      | { type: 'CONSENT' }
      | { type: 'START' }
      | { type: 'COMPLETE' }
      | { type: 'SUBMIT' }
      | { type: 'SUBMIT_OK' }
      | { type: 'SUBMIT_ERR'; error: string }
      | { type: 'RESET' };
  }
}).createMachine({
  id: 'patience-fingerprint-flow',
  initial: 'consent',
  context: {},
  states: {
    consent: {
      on: { CONSENT: 'ready' }
    },
    ready: {
      on: { START: { target: 'playing', actions: assign({ error: undefined }) }, RESET: 'ready' }
    },
    playing: {
      on: { COMPLETE: 'revealing', RESET: 'ready' }
    },
    revealing: {
      on: { SUBMIT: 'submitting', START: { target: 'playing', actions: assign({ error: undefined }) }, RESET: 'ready' }
    },
    submitting: {
      on: {
        SUBMIT_OK: 'archived',
        SUBMIT_ERR: { target: 'revealing', actions: assign({ error: ({ event }) => event.error }) }
      }
    },
    archived: {
      on: { START: { target: 'playing', actions: assign({ error: undefined }) }, RESET: 'ready' }
    }
  }
});
